import { render, staticRenderFns } from "./PrivilegeSelector.vue?vue&type=template&id=84072440&scoped=true"
import script from "./PrivilegeSelector.vue?vue&type=script&lang=ts"
export * from "./PrivilegeSelector.vue?vue&type=script&lang=ts"
import style0 from "./PrivilegeSelector.vue?vue&type=style&index=0&id=84072440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84072440",
  null
  
)

export default component.exports